const info = sessionStorage.getItem("user") || "";

export default {
    IS_LOGIN: Boolean(info),
    info: info ? JSON.parse(info) : {}
}